// extracted by mini-css-extract-plugin
module.exports = {"date":"Subscription_date__P1LC2"};